export default {
    created() {
        this.$root.$on('showModalAddInvite', this.showModalAddInvite);
        this.$root.$once('hook:beforeDestroy', () => {
            this.$root.$off('showModalAddInvite', this.showModalAddInvite);
        });
    },
    methods: {
        showModalAddInvite(playload) {
            this.$refs.modalAddInvite.open(playload);
        },
    },
};
